export default __webpack_public_path__ + "static/media/lastActivity_fake.5c1b79ae.png";